import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { UnAuthenticatedLayoutWithTheme } from '../UnAuthenticatedLayout';

import Docs1 from './ImagesRole/role1.png';
import Docs2 from './ImagesRole/role2.png';
import Docs3 from './ImagesRole/role3.png';
import Docs4 from './ImagesRole/role4.png';
import Docs5 from './ImagesRole/role5.png';
import Docs6 from './ImagesRole/role6.png';
import Docs7 from './ImagesRole/role7.png';
import Docs8 from './ImagesRole/role8.png';
import Docs9 from './ImagesRole/role9.png';
import Docs10 from './ImagesRole/role10.png';
import Docs11 from './ImagesRole/role11.png';
import Docs12 from './ImagesRole/role12.png';
import Docs13 from './ImagesRole/role13.png';
import Docs14 from './ImagesRole/role14.png';
import Docs15 from './ImagesRole/role15.png';
import Docs16 from './ImagesRole/role16.png';
import Docs17 from './ImagesRole/role17.png';
import Docs18 from './ImagesRole/role18.png';

export const RolesQuery = () => {
    const classes = useStyles();

    return (
        <UnAuthenticatedLayoutWithTheme showActions>
            <Container className={classes.root} maxWidth="lg">
                <Typography
                    variant="h2"
                    align="center"
                    className={classes.header}
                >
                    Organization Admin / Developer Responsibility
                </Typography>
                <Typography align="left" className={classes.sectionTitle}>
                    <b>User Management:</b>
                </Typography>
                <Typography className={classes.sectionText}>
                    Each user can be assigned any of the 2 primary roles:
                </Typography>
                <Typography className={classes.pointers}>
                    <b>1. Organization Admin</b>
                </Typography>
                <Typography className={classes.pointers2}>
                    <b> ✪ View/Add/Update/Delete - Application/s and User/s </b>
                </Typography>
                <Typography className={classes.pointers2}>
                    <b> ✪ View APIS </b>
                </Typography>
                <Typography className={classes.pointers2}>
                    <b> ✪ Reset Application Secret/s </b>
                </Typography>
                <Typography className={classes.pointers}>
                    <b>2. Developer</b>
                </Typography>
                <Typography className={classes.pointers2}>
                    <b> ✪ View Application </b>
                </Typography>
                <Typography className={classes.pointers2}>
                    <b> ✪ View APIS </b>
                </Typography>
                <Typography className={classes.pointers2}>
                    <b> ✪ Reset Application Secret </b>
                </Typography>
                <br></br>
                <div className={classes.docs1} />
                <Typography align="left" className={classes.sectionTitle}>
                    <b>Organization Admin role:</b>
                </Typography>
                <Typography className={classes.sectionText}>
                    The Org-Admin role is assigned to the first user of an
                    organization during the registration process on the B2B
                    portal. This role provides the following <br />
                    special access:
                </Typography>
                <br></br>
                <div className={classes.docs2} />
                <Typography align="left" className={classes.subtitle}>
                    User Management:
                </Typography>
                <Typography
                    variant="h5"
                    align="left"
                    className={classes.subtitle2}
                >
                    • Create User:
                </Typography>
                <Typography className={classes.sectionText2}>
                    Navigate to the <b>USERS</b> tab and select the{' '}
                    <b>CREATE</b> option:
                </Typography>
                <div className={classes.docs3} />
                <br></br>
                <Typography className={classes.sectionText2}>
                    Then fill in the user details and submit the form:
                </Typography>
                <div className={classes.docs4} />
                <br></br>
                <Typography
                    variant="h5"
                    align="left"
                    className={classes.subtitle2}
                >
                    • Delete User:
                </Typography>
                <Typography className={classes.sectionText2}>
                    Select the user(s) to enable the <b>DELETE</b> option:
                </Typography>
                <Typography className={classes.noteText}>
                    Note: This action is irreversible.
                </Typography>
                <div className={classes.docs5} />
                <Typography
                    variant="h5"
                    align="left"
                    className={classes.subtitle2}
                >
                    • Update User:
                </Typography>
                <Typography className={classes.sectionText2}>
                    o <b>Activated Users:</b> Click on the username to open the
                    edit user page
                </Typography>
                <div className={classes.docs6} />
                <Typography className={classes.sectionText2}>
                    o <b>Non-Activated user: </b> Click on the username to open
                    the edit user page
                </Typography>
                <div className={classes.docs7} />
                <Typography align="left" className={classes.subtitle}>
                    Application Management:
                </Typography>
                <Typography
                    variant="h5"
                    align="left"
                    className={classes.subtitle2}
                >
                    • Create Application:
                </Typography>
                <Typography className={classes.sectionText2}>
                    Navigate to the <b>APPLICATIONS</b> tab and select{' '}
                    <b>ADD APPLICATION</b>:
                </Typography>
                <div className={classes.docs8} />
                <Typography className={classes.sectionText3}>
                    * Enter the Name, Description, Select the API’s to access
                    and Callback URL (if needed) and click <b>Save</b>.
                </Typography>
                <Typography className={classes.sectionText3}>
                    * Mdmeid and scope is auto fetched at the time of
                    application save state.
                </Typography>
                <Typography className={classes.sectionText3}>
                    * Upon saving, a secret key is generated for the
                    application.
                </Typography>
                <Typography className={classes.noteText}>
                    Note: Store the secret key securely.
                </Typography>
                <div className={classes.docs9} />
                <div className={classes.docs10} />
                <Typography
                    variant="h5"
                    align="left"
                    className={classes.subtitle2}
                >
                    • Edit Application:
                </Typography>
                <Typography className={classes.sectionText2}>
                    Click on the desired application and select <b>EDIT</b>:
                </Typography>
                <div className={classes.docs11} />
                <Typography className={classes.sectionText3}>
                    * Fields that can be updated: Application Name, Description,
                    APIs list, Callback URL.
                </Typography>
                <Typography className={classes.sectionText3}>
                    * Secret key can be regenerated.
                </Typography>
                <br></br>
                <div className={classes.docs12} />
                <div className={classes.docs13} />
                <Typography
                    variant="h5"
                    align="left"
                    className={classes.subtitle2}
                >
                    • Delete Application:
                </Typography>
                <Typography className={classes.sectionText2}>
                    Click on the desired application, and then select{' '}
                    <b>DELETE</b>:
                </Typography>
                <Typography className={classes.noteText}>
                    Note: This action is irreversible.
                </Typography>
                <div className={classes.docs14} />
                <Typography align="left" className={classes.subtitle}>
                    Other Privileges:
                </Typography>
                <Typography
                    variant="h5"
                    align="left"
                    className={classes.subtitle2}
                >
                    • Assigning Additional Org-Admins:
                </Typography>
                <Typography className={classes.sectionText2}>
                    Existing Org-Admins can add additional Org-Admins from the
                    portal for the same organization if needed.
                </Typography>
                <Typography
                    variant="h5"
                    align="left"
                    className={classes.subtitle2}
                >
                    • APIS Access/View:
                </Typography>
                <Typography className={classes.sectionText2}>
                    Click on APIS tab to view all API’s available for the
                    organization user belongs to.
                </Typography>
                <div className={classes.docs15} />
                <Typography align="left" className={classes.sectionTitle}>
                    <b>Developer role:</b>
                </Typography>
                <Typography className={classes.sectionText}>
                    The Developer role is assigned by an Org-Admin to newly
                    added users within their organization.
                </Typography>
                <br></br>
                <div className={classes.docs16} />
                <br></br>
                <Typography className={classes.sectionText}>
                    This role provides limited access:
                </Typography>
                <Typography align="left" className={classes.subtitle0}>
                    Application Management:
                </Typography>

                <Typography
                    variant="h5"
                    align="left"
                    className={classes.subtitle2}
                >
                    • Update Application (Only Secret key re-generation):
                </Typography>
                <Typography className={classes.sectionText2}>
                    Navigate to the desired application, select <b>EDIT</b>, and
                    re-generate the secret key if necessary.
                </Typography>

                <div className={classes.docs17} />
                <div className={classes.docs18} />
                <Typography align="left" className={classes.subtitle}>
                    Other Privileges:
                </Typography>
                <Typography
                    variant="h5"
                    align="left"
                    className={classes.subtitle2}
                >
                    • APIS Access/View:
                </Typography>
                <Typography className={classes.sectionText2}>
                    Click on APIS tab to view all API’s available for the
                    organization user belongs to.
                </Typography>
                <div className={classes.docs15} />
                <Typography className={classes.sectionText}>
                    <b>
                        This structured role-based access control ensures that
                        administrative functions are handled securely while
                        developers have limited access necessary for their
                        tasks.
                    </b>
                </Typography>
            </Container>
        </UnAuthenticatedLayoutWithTheme>
    );
};

const useStyles = makeStyles(
    theme => ({
        root: {
            wordBreak: 'break-all',
            marginBottom: '120px',
        },
        header: {
            color: '#027B75',
            marginTop: '60px',
            marginBottom: '20px',
            paddingBottom: '5%',
            textDecoration: 'underline',
        },
        sectionTitle: {
            color: '#000000',
            marginTop: '60px',
            marginBottom: '30px',
            textDecoration: 'underline',
            fontSize: '30px',
        },
        subtitle0: {
            color: '#000000',
            marginTop: '30px',
            marginBottom: '20px',
            textDecoration: 'underline dashed',
            fontSize: '25px',
        },
        subtitle: {
            color: '#000000',
            marginTop: '60px',
            marginBottom: '20px',
            textDecoration: 'underline dashed',
            fontSize: '25px',
        },
        subtitle2: {
            color: '#000000',
            marginTop: '10px',
            marginBottom: '20px',
            marginLeft: '50px',
            textDecoration: 'underline dotted',
        },
        subtitle3: {
            marginBottom: '30px',
            marginLeft: '50px',
            color: '#292625',
            fontSize: '18px',
            lineHeight: '23px',
            letterSpacing: '0.18px',
            '& ion-icon': {
                fontSize: '18px',
                margin: '0 20px 0 5px',
                color: '#22bcb5',
            },
        },
        pointers: {
            color: '#034764',
            marginBottom: '10px',
            fontSize: '16px',
            lineHeight: '22px',
            letterSpacing: '0.18px',
            paddingLeft: '50px',
        },
        pointers2: {
            color: '#034764',
            marginBottom: '10px',
            fontSize: '15px',
            lineHeight: '22px',
            letterSpacing: '0.18px',
            paddingLeft: '100px',
        },
        sectionText: {
            marginBottom: '10px',
            color: '#292625',
            fontSize: '18px',
            lineHeight: '23px',
            letterSpacing: '0.18px',
            '& ion-icon': {
                fontSize: '18px',
                margin: '0 20px 0 5px',
                color: '#22bcb5',
            },
        },
        sectionText2: {
            marginBottom: '30px',
            marginLeft: '100px',
            color: '#292625',
            fontSize: '18px',
            lineHeight: '23px',
            letterSpacing: '0.18px',
            '& ion-icon': {
                fontSize: '18px',
                margin: '0 20px 0 5px',
                color: '#22bcb5',
            },
        },
        sectionText3: {
            marginBottom: '20px',
            marginLeft: '100px',
            color: '#292625',
            fontSize: '18px',
            lineHeight: '15px',
            letterSpacing: '0.18px',
            '& ion-icon': {
                fontSize: '18px',
                margin: '0 20px 0 5px',
                color: '#22bcb5',
            },
        },
        noteText: {
            marginTop: '-20px',
            marginBottom: '30px',
            fontWeight: 'bold',
            marginLeft: '100px',
            color: '#292625',
            fontSize: '14px',
            lineHeight: '23px',
            letterSpacing: '0.18px',
            '& ion-icon': {
                fontSize: '18px',
                margin: '0 20px 0 5px',
                color: '#22bcb5',
            },
        },
        docs1: {
            backgroundImage: `url('${Docs1}')`,
            height: '120px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '100px',
        },
        docs2: {
            backgroundImage: `url('${Docs2}')`,
            height: '80px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '30px',
        },
        docs3: {
            backgroundImage: `url('${Docs3}')`,
            height: '150px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '30px',
            marginLeft: '100px',
        },
        docs4: {
            backgroundImage: `url('${Docs4}')`,
            height: '500px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '20px',
            marginLeft: '100px',
        },
        docs5: {
            backgroundImage: `url('${Docs5}')`,
            height: '240px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '60px',
            marginLeft: '100px',
        },
        docs6: {
            backgroundImage: `url('${Docs6}')`,
            height: '600px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '60px',
            marginLeft: '100px',
        },
        docs7: {
            backgroundImage: `url('${Docs7}')`,
            height: '600px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '60px',
            marginLeft: '100px',
        },
        docs8: {
            backgroundImage: `url('${Docs8}')`,
            height: '150px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '60px',
            marginLeft: '100px',
        },
        docs9: {
            backgroundImage: `url('${Docs9}')`,
            height: '550px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '0px',
            marginLeft: '100px',
        },
        docs10: {
            backgroundImage: `url('${Docs10}')`,
            height: '501px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '50px',
            marginLeft: '100px',
        },
        docs11: {
            backgroundImage: `url('${Docs11}')`,
            height: '425px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '60px',
            marginLeft: '100px',
        },
        docs12: {
            backgroundImage: `url('${Docs12}')`,
            height: '570px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '0px',
            marginLeft: '100px',
        },
        docs13: {
            backgroundImage: `url('${Docs13}')`,
            height: '518px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '60px',
            marginLeft: '100px',
        },
        docs14: {
            backgroundImage: `url('${Docs14}')`,
            height: '525px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '60px',
            marginLeft: '100px',
        },
        docs15: {
            backgroundImage: `url('${Docs15}')`,
            height: '500px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '200px',
            marginLeft: '100px',
        },
        docs16: {
            backgroundImage: `url('${Docs16}')`,
            height: '80px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '30px',
        },
        docs17: {
            backgroundImage: `url('${Docs17}')`,
            height: '550px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '0px',
            marginLeft: '100px',
        },
        docs18: {
            backgroundImage: `url('${Docs18}')`,
            height: '528px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            marginBottom: '60px',
            marginLeft: '100px',
        },
    }),
    {
        name: 'NSARP_Docs',
    }
);
